import { assert } from '@ember/debug';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { getColorFromInitiativeTitle } from 'scaleflow/utils/colorClasses';

export default class ChatInputComponent extends Component {
  @tracked text = '';

  @action
  setText(e) {
    this.text = e.target.value;
  }

  @action
  propagateQuery(e) {
    if (this.isDisabled) return;
    e?.preventDefault?.();
    const { errors, success } = this.args.onSubmit(this.text);
    if (!errors && success) {
      this.text = '';
    }
  }

  @action
  handleEnterPress(e) {
    if ((e.key === 'Enter' || e.keyCode === 13) && !e.shiftKey) {
      e.preventDefault();
      this.propagateQuery();
    }
  }

  @action
  propagateStopConversationRequest() {
    if (!this.args.onStopConversationRequest) {
      assert(
        "Please pass an 'onStopConversationRequest' prop to the component",
      );
    }
    this.args.onStopConversationRequest();
  }

  get isDisabled() {
    return this.text.trim().length === 0;
  }

  @action
  handleInitiativeSelect(initiative) {
    if (this.args.onInitiativeSelect) {
      this.args.onInitiativeSelect(initiative);
    }
  }

  get backgroundColor() {
    if (this.args.initiative) {
      return getColorFromInitiativeTitle(this.args.initiative.title);
    }
    return 'bg-transparent';
  }
}
